import { render, staticRenderFns } from "./ChildrenLiveSearch.vue?vue&type=template&id=536ce672&scoped=true&"
import script from "./ChildrenLiveSearch.vue?vue&type=script&lang=js&"
export * from "./ChildrenLiveSearch.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenLiveSearch.vue?vue&type=style&index=0&id=536ce672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ce672",
  null
  
)

export default component.exports